import {
  N11OrderProduct,
  n11OrderProductFromResponse,
} from './N11OrderProduct';
import { N11OrderStatus } from './N11OrderStatus';

export interface N11Order {
  n11ID: string;
  products: N11OrderProduct[];
  status: N11OrderStatus;
  createdAt: Date;
}

export const n11OrderFromResponse = (responseData: any): N11Order => ({
  n11ID: responseData.n11_id,
  products: (responseData.products ?? []).map(n11OrderProductFromResponse),
  status: responseData.status,
  createdAt: new Date(responseData.created_at),
});
